import React, { memo } from 'react';
import { getLiteral } from 'utils/getLiteral';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

import './styles.scss';

const SectionTitle = memo(({ title, subtitle }) => {
    const theme = useTheme();
    return (
        <div className="billing-section-title">
            {title && (
                <div className="billing-section-title__title">
                    <Text type="subtitle" medium>
                        {getLiteral(title)}
                    </Text>
                </div>
            )}
            {subtitle && (
                <div className="billing-section-title__subtitle">
                    <Text type="body" color={theme.colors.utility.textSecondary}>
                        {getLiteral(subtitle)}
                    </Text>
                </div>
            )}
        </div>
    );
});

export default SectionTitle;
